import { render, staticRenderFns } from "./CorporateAnnouncementIpos.vue?vue&type=template&id=653ce1b7&scoped=true"
import script from "./CorporateAnnouncementIpos.vue?vue&type=script&lang=js"
export * from "./CorporateAnnouncementIpos.vue?vue&type=script&lang=js"
import style0 from "./CorporateAnnouncementIpos.vue?vue&type=style&index=0&id=653ce1b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ce1b7",
  null
  
)

export default component.exports